/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Master {

    @Serenity.Decorators.registerClass()
    export class SinonimDialog extends NoboxEntityDialog<SinonimRow, any> {
        protected getFormKey() { return SinonimForm.formKey; }
        protected getIdProperty() { return SinonimRow.idProperty; }
        protected getLocalTextPrefix() { return SinonimRow.localTextPrefix; }
        protected getNameProperty() { return SinonimRow.nameProperty; }
        protected getService() { return SinonimService.baseUrl; }
        protected getDeletePermission() { return SinonimRow.deletePermission; }
        protected getInsertPermission() { return SinonimRow.insertPermission; }
        protected getUpdatePermission() { return SinonimRow.updatePermission; }

        protected form = new SinonimForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();
            if (this.isNew()) {
                if ($.cookie("LanguagePreference")) {
                    this.form.Bhs.set_value($.cookie("LanguagePreference"));
                } else {
                    this.form.Bhs.set_value("en");
                }
            }
        }
    }
}